<mat-card>
	<mat-card-header>
		<mat-card-title>
			Graduating {{!hasDifferentCounts() ? uniqueStudents.length :
			(resolveOnlyChosenStudents().length.toString() + '/' + uniqueStudents.length.toString())}} Child(ren)
			<mat-icon *ngIf="isLoading">
				<mat-spinner diameter="20"> </mat-spinner>
			</mat-icon>
		</mat-card-title>
		<button class="close-button" mat-mini-fab (click)="closeDialog(false)">
			<mat-icon>close</mat-icon>
		</button>
	</mat-card-header>

	<mat-card-content>
		<div class="padding-vertical-md" *ngIf="!isLoading">

			<div class="row">
				<div class="col-lg-7">
					<div class="table-responsive">
						<mat-table [dataSource]="tableDataSources[0]" class="mat-elevation-z1">

							<ng-container matColumnDef="EDIT">
								<mat-header-cell *matHeaderCellDef>
									<button mat-icon-button color="primary" (click)="toggleAllStudents()"
										*ngIf="!hasAtLeastOneStudent()">
										<mat-icon>check_box_outline_blank</mat-icon>
									</button>
									<button mat-icon-button color="primary" (click)="toggleAllStudents()"
										*ngIf="hasAtLeastOneStudent() && hasDifferentCounts()">
										<mat-icon>indeterminate_check_box</mat-icon>
									</button>
									<button mat-icon-button color="primary" (click)="toggleAllStudents()"
										*ngIf="hasAtLeastOneStudent() && !hasDifferentCounts()">
										<mat-icon>check_box</mat-icon>
									</button>
								</mat-header-cell>
								<mat-cell *matCellDef="let element">
									<button mat-icon-button color="primary" (click)="toggleStudent(element)"
										[hidden]="element.ENABLED"
										[ngClass]="{'disabled cursor-default': element.GRADUATED}">
										<mat-icon>check_box_outline_blank</mat-icon>
									</button>
									<button mat-icon-button color="primary" (click)="toggleStudent(element)"
										[hidden]="!element.ENABLED"
										[ngClass]="{'disabled cursor-default': element.GRADUATED}">
										<mat-icon>check_box</mat-icon>
									</button>
								</mat-cell>
							</ng-container>

							<ng-container matColumnDef="GRADUATION_CHECK">
								<mat-header-cell *matHeaderCellDef> <mat-icon>school</mat-icon> </mat-header-cell>
								<mat-cell *matCellDef="let element">
									<mat-icon *ngIf="!isTerminated(element)" color="primary"
										[matTooltip]="'Okay to Graduate'">done</mat-icon>
									<mat-icon *ngIf="isTerminated(element) && !checkGraduated(element)" color="accent"
										[matTooltip]="getTerminationMessage(element)">warning</mat-icon>
									<mat-icon *ngIf="checkGraduated(element)" color="primary"
										[matTooltip]="getAlreadyGraduatedMessage(element)">school</mat-icon>
								</mat-cell>
							</ng-container>

							<ng-container matColumnDef="NAME">
								<mat-header-cell *matHeaderCellDef> Child Name </mat-header-cell>
								<mat-cell *matCellDef="let element"> {{element.NAME}} </mat-cell>
							</ng-container>

							<ng-container matColumnDef="MSD_NUMBER">
								<mat-header-cell *matHeaderCellDef> MSD Number </mat-header-cell>
								<mat-cell *matCellDef="let element">
									{{element.MSD_NUMBER}}
								</mat-cell>
							</ng-container>



							<mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
							<mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
						</mat-table>
					</div>
				</div>

				<div class="col-lg-5">

					<div>

						<div class="row">
							<mat-form-field class="padding-md col-lg-12">
								<mat-label>Graduation Date</mat-label>
								<input matInput [matDatepicker]="graduationDatePicker"
									(click)="graduationDatePicker.open()" [(ngModel)]="graduationDate"
									startView="multi-year" [max]="graduationDateOptions.maxDate">
								<mat-datepicker-toggle matSuffix [for]="graduationDatePicker"></mat-datepicker-toggle>
								<mat-datepicker #graduationDatePicker></mat-datepicker>

							</mat-form-field>
						</div>
					</div>
				</div>
			</div>

			<hr />

			<mat-card-actions class="inline">
				<confirm-popover class="margin-bottom-xs" [buttonType]="'string'" [color]="'primary'"
					[popoverMsg]="'Confirm Graduation'" [popoverConfirmText]="'Graduate'" [buttonTxt]="'Graduate'"
					[popoverConfirmColor]="'primary'" (onConfirm)="graduate()"
					[disabled]="isSubmitting || !hasAtLeastOneStudent() || (msg && msg.SUCCESS!)">
				</confirm-popover>

				<button type="button" mat-icon-button *ngIf="isSubmitting">
					<mat-icon>
						<mat-spinner diameter="20"> </mat-spinner>
					</mat-icon>
				</button>
			</mat-card-actions>
		</div>
		<app-msg class="margin-left-sm" [msg]="msg" *ngIf="msg?.MSG"></app-msg>
	</mat-card-content>
</mat-card>